<template>
  <ActivityListPage />
</template>

<script lang="ts" setup>
import ActivityListPage from "@/features/Activity/views/ActivityListPage.vue";

useHead({
  title: "Aktivitas Relawan",
});
</script>
